<template>
  <div class="appMain">
    <el-container>
      <el-header class="header">
        <div class="logo" @click="goHome">陵企通</div>
<!--        <el-button @click="goHome">回到首页</el-button>-->
        <el-button @click="goOut">退出登录</el-button>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu :default-active="activeIndex" active-text-color="#0D56BD" @select="handleSelect" style="height: calc(100vh - 60px);">
            <el-menu-item index="1">
              <i class="el-icon-menu"></i>
              <span slot="title">公司信息</span>
            </el-menu-item>
            <div v-if="entClassify === '1'">
              <el-menu-item index="2">
                <i class="el-icon-menu"></i>
                <span slot="title">发布需求</span>
              </el-menu-item>
              <el-menu-item index="3">
                <i class="el-icon-menu"></i>
                <span slot="title">我的需求</span>
              </el-menu-item>
              <el-menu-item index="6">
                <i class="el-icon-menu"></i>
                <span slot="title">发布诉求</span>
              </el-menu-item>
              <el-menu-item index="7">
                <i class="el-icon-menu"></i>
                <span slot="title">我的诉求</span>
              </el-menu-item>
<!--              <el-menu-item index="4">-->
<!--                <i class="el-icon-menu"></i>-->
<!--                <span slot="title">我的政策</span>-->
<!--              </el-menu-item>-->
              <el-menu-item index="5">
                <i class="el-icon-menu"></i>
                <span slot="title">我的活动</span>
              </el-menu-item>
              <el-menu-item index="8">
                <i class="el-icon-menu"></i>
                <span slot="title">租房管理</span>
              </el-menu-item>
              <el-menu-item index="11">
                <i class="el-icon-menu"></i>
                <span slot="title">我的报价</span>
              </el-menu-item>
            </div>
            <el-menu-item index="9" v-if="entClassify === '2' && entFinanceKind === '1'">
              <i class="el-icon-menu"></i>
              <span slot="title">我的产品</span>
            </el-menu-item>
            <el-menu-item index="10" v-if="entClassify === '2' && entFinanceKind === '2'">
              <i class="el-icon-menu"></i>
              <span slot="title">我的产品</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main style="height: calc(100vh - 60px);">
<!--          <keep-alive>-->
            <router-view/>
<!--          </keep-alive>-->
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {removeEnterprise, removeToken, removeUser} from "@/utils/auth";

export default {
  name: 'appMain',
  data() {
    return {
      activeIndex: '1',
      entClassify: '2',
      entFinanceKind: null,
    }
  },
  mounted() {
    this.getEntInfo();
    this.activeIndex = this.$route.meta.memberCenterIndex.toString()
  },
  methods: {
    getEntInfo() {
      this.$http.get('/api/getEntInfo').then(res => {
        if (res.data) {
          this.entClassify = res.data.entClassify;
          this.entFinanceKind = res.data.entFinanceKind;
        }
      })
    },
    handleSelect(key) {
      if (key === '1') {
        this.$router.push('/userProfile')
      } else if (key === '2') {
        this.$router.push('/releaseRequirements')
      } else if (key === '3') {
        this.$router.push('/myRequest')
      } else if (key === '4') {
        this.$router.push('/myDeclare')
      } else if (key === '5') {
        this.$router.push('/myActivity')
      } else if (key === '6') {
        this.$router.push('/releaseAppeal')
      } else if (key === '7') {
        this.$router.push('/myAppeal')
      } else if (key === '8') {
        this.$router.push('/myRentalService')
      } else if (key === '9') {
        this.$router.push('/myBankProduct')
      } else if (key === '10') {
        this.$router.push('/myInsuranceProduct')
      } else if (key === '11') {
        this.$router.push('/myOffer')
      }
    },
    goHome() {
      // this.$router.push('/')
      window.open('/')
    },
    goOut() {
      this.$confirm('确定要退出登录吗？', '系统提示', { confirmButtonText: '退出登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
        removeToken()
        removeUser()
        removeEnterprise()
        location.href = '/loginRegister'
      }).catch(() => {

      })
    },
  }
}
</script>

<style scoped lang="scss">
.appMain {

}

.logo {
  width: 200px;
  line-height: 60px;
  text-align: center;
  font-size: 30px;
  color: #ffffff;
  background: #0D56BD;
  font-weight: bold;
}

.logo:hover {
  cursor: pointer;
}

.header {
  border-bottom: solid 1px #e6e6e6;
  background: #ffffff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
}
</style>